import { miscSlice } from "./misc";
import { dialogSlice } from "./dialogs";
import { queueCountSlice } from "./queueCount";

export const rootStore = {
    misc: miscSlice,
    dialog: dialogSlice,
    queueCount: queueCountSlice
}

// Export the stores directly
export const { misc: miscStore, dialog: dialogStore, queueCount: queueCountStore } = rootStore;